import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  Renderer2,
  TemplateRef
} from "@angular/core";
import { menuType } from "../../constants/menu/menu.type";
import { MenuConfigService } from "../services/menu-config.service";
import { SidenavService } from "../services/sidenav.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { MashupService } from "src/app/features/http-services/mashup.service";
import { Subscription } from "rxjs";
import { UserService } from "../../user/services/user.service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { StorageService } from "src/app/features/http-services/storage.service";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { ApiService } from "src/app/features/http-services/api.service";

@Component({
  selector: 'xchange-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit, AfterContentChecked, AfterViewChecked {
  _opened: boolean = false;
  @ViewChild("appHeader") appHeader!: ElementRef;
  height: number = 0;

  menuType!: string;
  screenWidth: number = window.innerWidth;
  screenHeight: number = window.innerHeight;
  @ViewChild("sidebarContent") sidebarContentRef: ElementRef | any;
  @ViewChild("sidebar") sidebar: ElementRef | any;

  sidenavConfig: any = {
    dock: false,
    mode: "push",
    sidebarClass: "main-side-nav",
    showBackdrop: true,
    dockedSize: "0",
    backdropClass: "main-side-nav-backdrop",
    closeOnClickBackdrop: true,
  };

  hideSideBar = false;
  isMashupSub!: Subscription;
  accountInfoSetSub!: Subscription;
  isShipToUserSub!: Subscription;
  sliderOptionsForCustomerMsg: OwlOptions = {
    loop: false,
    navText: ["", ""],
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 2,
      },
      940: { items: 3 },
    },
    nav: false,
    margin: 15,
  };
  isCustomer: boolean = false;
  showCustomerMessages: boolean = true;
  customerMessageAlerts = [
    {
      msg: "Valued customer - latest news on Coronavirus.",
      src: "/assets/icons/feather-alert-octagon.svg",
    },
    {
      msg: "The FSC (Fuel Surcharge) for this week is 55%",
      src: "/assets/icons/awesome-gas-pump.svg",
    },
    {
      msg: "For quick order status updates, text your Mohawk Order Reference or Purchase Order Number to (520)-277-9937 to  receive brief, up-to-date order status information.",
      src: "/assets/icons/zocial-call.svg",
    },
    {
      msg: "Truck tracking now available by clicking on Today’s Shipments.",
      src: "/assets/icons/awesome-truck.svg",
    },
    {
      msg: "Mohawk Residential import Freight Surcharge Revision Effective 10.3.22",
      src: "/assets/icons/awesome-box.svg",
    },
  ];
  salePersonNotifications: any = [];
  modalRef!: BsModalRef;
  uid: any = "";
  isCommercial: boolean = false;
  spinnerLoading = false;
  salesTeamData: any = [];

  constructor(
    private sideNav: SidenavService,
    private cd: ChangeDetectorRef,
    private menuConfig: MenuConfigService,
    public router: Router,
    private mashupService: MashupService,
    public userService: UserService,
    private storageService: StorageService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    public modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private apiService: ApiService,
  ) {
    document.body.classList.add("add-scroll");
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (
          this.router.url.includes("residential/account/search") ||
          this.router.url.includes("commercial/account/search") ||
          this.router.url.includes("residential/post-modification") ||
          this.router.url.includes("commercial/post-modification") ||
          this.router.url.includes("commercial/account/multi-account") ||
          this.router.url.includes("residential/account/multi-account")
        ) {
          this.hideSideBar = true;

          //   this.sidebar.close();
        } else {
          this.hideSideBar = false;
        }
        this.isMashupSub = mashupService.isMashup.subscribe((isMashup) => {
          if (isMashup) {
            if (
              this.router.url !== "/residential" &&
              this.router.url !== "/commercial"
            ) {
              this.hideSideBar = true;
            }
          }
        });
        this.accountInfoSetSub = this.userService.accountInfoSet.subscribe(
          (accountInfoSet) => {
            if (
              this.router.url.includes("contact-us") ||
              this.router.url.includes("my-profile")
            ) {
              if (!accountInfoSet) this.hideSideBar = true;
            }
          }
        );

        if (window.innerWidth > 993) {
          let showNotifications = localStorage.getItem("showSalesNotification");
          if (showNotifications == "false") {
            this.showCustomerMessages = false;
          } else {
            this.showCustomerMessages = true;
          }
          const scrollerElement = document.getElementsByClassName(
            "ng-sidebar__content"
          )[0];
          if (this.hideSideBar == false) {
            if (scrollerElement) {
              this.renderer.setStyle(
                scrollerElement,
                "padding",
                "0px 0px 0px 0px"
              );
            }
          } else {
            if (scrollerElement) {
              this.renderer.setStyle(scrollerElement, "padding", "unset");
            }
          }
        }
      }
    });
  }

  @HostListener("window:scroll", ["$event"])
  doSomething(event: any) {
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.screenWidth = event.target.innerWidth;
    this.screenHeight = window.innerHeight;
    this.updateConfig(this.screenWidth);
    this.calculateMinHeight(this.appHeader.nativeElement);
  }

  ngOnInit(): void {
    const scrollerElement = document.getElementsByClassName(
      "ng-sidebar__content"
    )[0];
    if (scrollerElement) {
      this.renderer.setStyle(scrollerElement, "overflow", "hidden");
    }
    this.updateConfig(window.innerWidth);
    this.storageService.getItem("userInfo").subscribe((response: any) => {
      this.isCustomer =
        !response?.isCSR &&
        !response?.isCSRSuperAdmin &&
        !response?.isProductManager &&
        !response?.isSalesOps &&
        !response?.isSalesPerson &&
        !response?.isFinancialSuperAdmin &&
        !response?.isFinancialUser &&
        !response?.isIsAdmin
          ? true
          : false;
    });

    this.userService.getSalePersonNotification().subscribe((response: any) => {
      response.map((item: any, index: any) => {
        let name = `notification${index + 1}`;
        if (item[name] == "on") {
          this.salePersonNotifications.push(this.customerMessageAlerts[index]);
        }
      });
    });

    let showNotifications = localStorage.getItem("showSalesNotification");
    if (showNotifications == "false") {
      this.showCustomerMessages = false;
    }
    if (this.router.url.includes("post-modification")) {
      this.showCustomerMessages = false;
    }
  }

  customerSupport(template3: TemplateRef<any>) {
    this.uid = this.storageService.uid;
    this.isCommercial = this.uid?.split("_")[3] === "82";
    this.spinnerLoading = true;
    this.apiService.getSalesTeam(this.uid).subscribe((data: any) => {
      this.spinnerLoading = false;
      this.salesTeamData = data?.custSalesPersonList || [];
    });
    this.modalRef = this.modalService.show(template3, {
      id: "customer-service",
      class: "modal-lg modal-dialog-centered",
      backdrop: "static",
      keyboard: false,
    });
}

  ngAfterViewInit() {
    this.calculateMinHeight(this.appHeader.nativeElement);
    this.menuConfig.currentState.subscribe((_menuType) => {
      this.menuType = _menuType;
      this.sidenavConfig["dock"] =
        this.menuType === menuType.sideNav && this.screenWidth > 993
          ? true
          : false;
      this.sidenavConfig["dockedSize"] =
        this.menuType === menuType.sideNav ? "0px" : "0px";
    });
    this.sideNav.currentState.subscribe((open) => (this._opened = open));
    this.cd.detectChanges();
  }

  updateConfig(screenWidth: number) {
    if (screenWidth <= 993) {
      this.sidenavConfig.dock = false;
    } else {
      this.sidenavConfig.dock = true;
    }
  }

  ngOnDestroy(): void {
    this.isMashupSub.unsubscribe();
  }

  hideSidebar() {
    this.sideNav.hide();
  }

  toggleSidebar() {
    this._opened = !this._opened;
  }

  calculateMinHeight(el: HTMLElement): void {
    const minHeight: any = this.screenHeight - el.offsetHeight;
    localStorage.setItem("minHeight", minHeight);
    return minHeight;
    // localStorage.setItem("minHeight", minHeight);
    // container.style.minHeight = `${minHeight}px`;
  }
  ngAfterViewChecked(): void {
    if (this.appHeader.nativeElement.offsetHeight !== this.height) {
      this.height = this.appHeader.nativeElement.offsetHeight;
      this.menuConfig.headerOffSetHeight.next(this.height);
    }
  }
  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }
  closeSidebar(event: any) {
    this._opened = false;
  }

  hideCustomerMsg() {
    this.showCustomerMessages = false;
    localStorage.setItem("showSalesNotification", "false");
  }

  showCustomerMsg() {
    this.showCustomerMessages = true;
    localStorage.setItem("showSalesNotification", "true");
  }

  onDismissAlert(dismissedAlert: any) {
    this.salePersonNotifications = this.salePersonNotifications.filter(
      (message: any) => message !== dismissedAlert
    );
  }
}
